import { useMemo } from "react"

import {
  FindSpotlightsByOrganizationIdResponseDto,
  GenerateAlertsResponseDto,
} from "~/gen/api"
import { SpotlightBoxProps } from "~/pages/Brand/Home/components/DashboardAlerts/SpotlightBox"
import { useAlertMessage } from "~/pages/Brand/Home/hooks/useAlertMessage"

export type SpotlightItem = {
  id: string
  count: number
  props: SpotlightBoxProps
}

export const useSpotlightItems = (
  dashboardAlerts: GenerateAlertsResponseDto | undefined,
  spotlights: FindSpotlightsByOrganizationIdResponseDto | undefined
): SpotlightItem[] => {
  const getAlertMessage = useAlertMessage()

  const spotlightItems: SpotlightItem[] = useMemo(() => {
    return [
      ...(dashboardAlerts?.alertValues || []).map((alertValue) => ({
        count: alertValue.value,
        id: alertValue.alert.id,
        props: {
          targetUrl: `${alertValue.alert.targetUrl}?${alertValue.filter.params}`,
          description: getAlertMessage(alertValue.alert.key),
          count: alertValue.value,
        },
      })),
      ...(spotlights?.spotlights || []).map((spotlight) => ({
        count: spotlight.count,
        id: spotlight.id,
        props: {
          targetUrl: `${spotlight.pageUrl}?viewId=${spotlight.id}`,
          description: spotlight.name,
          count: spotlight.count,
        },
      })),
    ].sort((a, b) => b.count - a.count)
  }, [dashboardAlerts, getAlertMessage, spotlights])

  return spotlightItems
}
